/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Required_TitleInputs */



/**
* | output |
* | --- |
* | "The event text or voice does not match the rendered audio. Render or record this event." |
*
* @param {Event_Ad_Render_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_required_title = /** @type {((inputs?: Event_Ad_Render_Required_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Required_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "de") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "it") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "es") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
	return /** @type {LocalizedString} */ ("The event text or voice does not match the rendered audio. Render or record this event.")
});